import { useContext, useEffect, useState } from 'react';
import { childsMock, guestsMock, italianGuestsMock } from './mocks';
import useGuestHook from './hooks/Guest.hook';
import { ApiContext } from 'utils/networking/Api.context';

export default function useGuestValidation({
  hotelId,
  selectedPms,
  formState,
  isDomestic,
  guestType,
}) {
  const { API } = useContext(ApiContext);
  const [pmsConfig, setPmsConfig] = useState(null);
  const [hotelConfig, setHotelConfig] = useState(null);
  const [mock, setMock] = useState(guestsMock[0]);
  const { snakeToCamel } = useGuestHook();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const [pms, hotel] = await Promise.all([
          API.pmsConfigDynamicFormRequest({ pmsId: selectedPms.id }),
          API.getOneHotel({ hotelId }),
        ]);
        setPmsConfig(pms);
        setHotelConfig(hotel);
      } catch (error) {
        console.error('Error loading configs:', error);
      }
    };

    fetchConfig();
  }, [selectedPms.id, hotelId]);

  useEffect(() => {
    if (!pmsConfig || !hotelConfig || !formState.form) {
      return;
    }

    const defaultMock = getDefaultMock();

    const supportedFields = pmsConfig?.config_dynamic_form?.supportedFields?.map(
      field => field.civitfun
    );

    if (!supportedFields) {
      setMock(defaultMock);
      return;
    }

    const activeFieldNames = getActiveFieldNames();

    const filteredMock = filterMockFields(defaultMock, activeFieldNames);

    setMock(filteredMock);
  }, [pmsConfig, hotelConfig, formState.form, formState.isDynamicForm, guestType, isDomestic]);

  const getDefaultMock = () => {
    if (guestType === 'child') {
      return childsMock[getRandomInt(0, childsMock.length - 1)];
    }

    const defaultMock = hotelConfig?.country === 'IT' ? italianGuestsMock : guestsMock;
    return defaultMock[getRandomInt(0, defaultMock.length - 1)];
  };

  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  const getActiveFieldNames = () => {
    const fieldGroupName = `${guestType}_${isDomestic ? '1' : '0'}`;

    if (formState.isDynamicForm && formState.form[fieldGroupName]) {
      return formState.form[fieldGroupName]
        .filter(field => field.state === 'active')
        .map(field => snakeToCamel(field.name));
    } else if (!formState.isDynamicForm && Array.isArray(formState.form)) {
      return formState.form
        .filter(field => field.state === 'active')
        .map(field => snakeToCamel(field.name));
    }

    return [];
  };

  const filterMockFields = (mockToFilter, activeFieldNames) => {
    return {
      ...mockToFilter,
      fields: mockToFilter.fields.filter(field =>
        activeFieldNames.includes(snakeToCamel(field.key))
      ),
    };
  };

  return { mock, setMock };
}
